import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import {
  ACHIEVEMENT_RECORDS_ALL,
  ACHIEVEMENT_RECORDS_CHANGE_STATUS,
  ACHIEVEMENT_RECORDS_CREATE,
  ACHIEVEMENT_RECORDS_LIST,
  ACHIEVEMENT_RECORDS_STUDENT,
  ACHIEVEMENT_RECORDS_TYPES,
  GLOBAL_STATE,
} from '../constants/actionTypes'
import * as actionCreators from './actions'
import { initialState } from './initialState'

export const ACHIEVEMENT_RECORDS = GLOBAL_STATE

const achievementRecordsSlice = createSlice({
  name: ACHIEVEMENT_RECORDS,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(actionCreators.achievementRecordsAllClear, state => {
      state[ACHIEVEMENT_RECORDS_ALL] = initialState().ACHIEVEMENT_RECORDS_ALL
    })

    builder
      .addCase(actionCreators.achievementRecordsAll.pending, state => {
        state[ACHIEVEMENT_RECORDS_ALL].loading = true
      })
      .addCase(actionCreators.achievementRecordsAll.rejected, (state, action) => {
        state[ACHIEVEMENT_RECORDS_ALL].loading = false
        state[ACHIEVEMENT_RECORDS_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.achievementRecordsAll.fulfilled, (state, action) => {
        state[ACHIEVEMENT_RECORDS_ALL].loading = false
        state[ACHIEVEMENT_RECORDS_ALL].error = null
        state[ACHIEVEMENT_RECORDS_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.achievementRecordsChangeStatus.pending, state => {
        state[ACHIEVEMENT_RECORDS_CHANGE_STATUS].loading = true
      })
      .addCase(actionCreators.achievementRecordsChangeStatus.rejected, (state, action) => {
        state[ACHIEVEMENT_RECORDS_CHANGE_STATUS].loading = false
        state[ACHIEVEMENT_RECORDS_CHANGE_STATUS].error = action.payload as AxiosError
      })
      .addCase(actionCreators.achievementRecordsChangeStatus.fulfilled, (state, action) => {
        state[ACHIEVEMENT_RECORDS_CHANGE_STATUS].loading = false
        state[ACHIEVEMENT_RECORDS_CHANGE_STATUS].error = null
        state[ACHIEVEMENT_RECORDS_CHANGE_STATUS].data = action.payload
      })

    builder
      .addCase(actionCreators.achievementRecordsCreate.pending, state => {
        state[ACHIEVEMENT_RECORDS_CREATE].loading = true
      })
      .addCase(actionCreators.achievementRecordsCreate.rejected, (state, action) => {
        state[ACHIEVEMENT_RECORDS_CREATE].loading = false
        state[ACHIEVEMENT_RECORDS_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.achievementRecordsCreate.fulfilled, (state, action) => {
        state[ACHIEVEMENT_RECORDS_CREATE].loading = false
        state[ACHIEVEMENT_RECORDS_CREATE].error = null
        state[ACHIEVEMENT_RECORDS_CREATE].data = action.payload
      })

    builder.addCase(actionCreators.achievementRecordsListClear, state => {
      state[ACHIEVEMENT_RECORDS_LIST] = initialState().ACHIEVEMENT_RECORDS_LIST
    })

    builder
      .addCase(actionCreators.achievementRecordsList.pending, state => {
        state[ACHIEVEMENT_RECORDS_LIST].loading = true
      })
      .addCase(actionCreators.achievementRecordsList.rejected, (state, action) => {
        state[ACHIEVEMENT_RECORDS_LIST].loading = false
        state[ACHIEVEMENT_RECORDS_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.achievementRecordsList.fulfilled, (state, action) => {
        state[ACHIEVEMENT_RECORDS_LIST].loading = false
        state[ACHIEVEMENT_RECORDS_LIST].error = null
        state[ACHIEVEMENT_RECORDS_LIST].data = action.payload
      })

    builder.addCase(actionCreators.achievementRecordsStudentClear, state => {
      state[ACHIEVEMENT_RECORDS_STUDENT] = initialState().ACHIEVEMENT_RECORDS_STUDENT
    })

    builder
      .addCase(actionCreators.achievementRecordsStudent.pending, state => {
        state[ACHIEVEMENT_RECORDS_STUDENT].loading = true
      })
      .addCase(actionCreators.achievementRecordsStudent.rejected, (state, action) => {
        state[ACHIEVEMENT_RECORDS_STUDENT].loading = false
        state[ACHIEVEMENT_RECORDS_STUDENT].error = action.payload as AxiosError
      })
      .addCase(actionCreators.achievementRecordsStudent.fulfilled, (state, action) => {
        state[ACHIEVEMENT_RECORDS_STUDENT].loading = false
        state[ACHIEVEMENT_RECORDS_STUDENT].error = null
        state[ACHIEVEMENT_RECORDS_STUDENT].data = action.payload
      })

    builder.addCase(actionCreators.achievementRecordsTypesClear, state => {
      state[ACHIEVEMENT_RECORDS_TYPES] = initialState().ACHIEVEMENT_RECORDS_TYPES
    })

    builder
      .addCase(actionCreators.achievementRecordsTypes.pending, state => {
        state[ACHIEVEMENT_RECORDS_TYPES].loading = true
      })
      .addCase(actionCreators.achievementRecordsTypes.rejected, (state, action) => {
        state[ACHIEVEMENT_RECORDS_TYPES].loading = false
        state[ACHIEVEMENT_RECORDS_TYPES].error = action.payload as AxiosError
      })
      .addCase(actionCreators.achievementRecordsTypes.fulfilled, (state, action) => {
        state[ACHIEVEMENT_RECORDS_TYPES].loading = false
        state[ACHIEVEMENT_RECORDS_TYPES].error = null
        state[ACHIEVEMENT_RECORDS_TYPES].data = action.payload
      })
  },
})

export const { reducer: achievementRecordsReducer } = achievementRecordsSlice
